import { render, staticRenderFns } from "./ParticipantsMenu.vue?vue&type=template&id=5163ed28&"
import script from "./ParticipantsMenu.vue?vue&type=script&lang=js&"
export * from "./ParticipantsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports